// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7iS9Q","rootMobile":"styles_rootMobile__1kUud"};